<section id="mu-forbidden" class="mu-cant-access">
  <div class="p-grid">
    <div class="p-col-12 mu-without-padding"><i class="fas fa-warning" aria-hidden="true"></i></div>
    <h1 class="p-col-12 mu-without-padding" [innerHTML]="'common.unauthorized.title' | translate"></h1>
    <p class="p-col-12 mu-without-padding" [innerHTML]="'common.unauthorized.textForbidden' | translate"></p>
  </div>
</section>
